/* ADD FILE */
/* UNTAPPED - COLLECTION PAGE BY PRODUCT TAG */

/**
 * A general mechanism that allows the collection cards to be modfified dependent on the
 * product tags for the product.
 * 
 * For now that is limited to just the price - the product element is output in too many places.
 * The price is only output in card-price.liquid
 * 
 * We stop the underlying Kalles price from flashing before we update it by initially hiding it, then
 * setting the class 'price--ready' after we have updated.
 * 
 * Used for:
 * - Curtains and blinds that don't have price. 
 */

import { onAddElement } from './stripes-utils.js';

const TAG = 'stripes-price-quoted';
const LABEL = 'Quote on request';

onAddElement({
  root: document.body,
  selector: '.hdt-price-wrapp[data-product-tags]',
  onNode(el) {
    const tags = el.dataset.productTags.split(',').map(t => t.trim());
    if (!tags.includes(TAG)) return;
    applyPriceOnRequest(el);
  }
});

function applyPriceOnRequest(el) {
  if (el.dataset.priceOnRequest === 'true') return;
  el.dataset.priceOnRequest = 'true';

  // Hide compare-at prices
  el.querySelectorAll('hdt-compare-at-price, s.wpd-ext-compare-at-price')
    .forEach(e => e.style.display = 'none');

  // Replace money elements with label, mark ready
  el.querySelectorAll('hdt-price, hdt-qty-price').forEach(priceEl => {
    priceEl.querySelectorAll('.hdt-money').forEach(m => m.textContent = '');
    [...priceEl.childNodes]
      .filter(n => n.nodeType === Node.TEXT_NODE)
      .forEach(n => n.textContent = '');
    priceEl.insertAdjacentText('beforeend', LABEL);
    priceEl.classList.add('price--ready');
  });
}